import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import "./FormularioExamen.css";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura";
import { plantelDeMatricula } from "../utilities/plantel";

// Aviso mientras el catalogo de conceptos no esta listo (o si no se pudo cargar): no se muestran precios
// inventados. Lo usa tambien FormularioDiplomas.
export const AvisoCatalogo = ({ estado }) => (
  <div className="Formulario-error">
    <p>
      {estado === "error"
        ? "No se pudieron cargar los conceptos y sus precios. Revisa tu conexión y recarga la página."
        : "Cargando conceptos y precios..."}
    </p>
  </div>
);

// Si el alumno regresa desde Forma de pago, la tabla que dejo este formulario trae lo que habia elegido:
// se recupera de ahi (antes se volvia a "Ninguno"). Si la tabla es de otro formulario, null.
export const seleccionExamenDesdeTabla = (tabla) => {
  if (!Array.isArray(tabla) || tabla.length === 0 || !tabla.every((t) => t.clave === "15" || t.clave === "27")) return null;
  const cuantos = (clave) => String(tabla.filter((t) => t.clave === clave).length);
  return { examenes: cuantos("15"), cursos: cuantos("27") };
};

const FormularioExamen = ({
  conceptos = [],
  estadoCatalogo = "listo",
  alumno = { codigo: "0000000000" },
  precio = 0,
  cambiarPagar = () => {},
  tablaConceptos,
  cambiarPrecio = () => {},
  cambiarDatosPago = () => {},
  cambiarTablaConceptos = () => {},
}) => {
  const history = useHistory();
  const [seleccionPrevia] = useState(() => seleccionExamenDesdeTabla(tablaConceptos));
  const [checked, cambiarChecked] = useState(seleccionPrevia || { examenes: "0", cursos: "0" });
  const [error, cambiarError] = useState(false);

  // Solo se ofrece lo que existe y esta activo en el catalogo (antes habia precios de respaldo fijos en el codigo:
  // si el concepto se desactivaba o el catalogo no cargaba, se cobraba con un precio que podia ser viejo).
  const dataExamen = conceptos.find(c => c.clave === "15") || null;
  const dataCurso = conceptos.find(c => c.clave === "27") || null;
  const precioExamen = dataExamen ? Number(dataExamen.precio) : 0;
  const precioCurso = dataCurso ? Number(dataCurso.precio) : 0;

  const HandleOnChange = (e) => {
    cambiarChecked({ ...checked, [e.target.name]: e.target.value });
    cambiarError(false);
  };

  // Al entrar sin una seleccion previa de este formulario se empieza de cero
  useEffect(() => {
    if (!seleccionPrevia) {
      cambiarPrecio(0);
      cambiarTablaConceptos([]);
    }
  }, [seleccionPrevia, cambiarPrecio, cambiarTablaConceptos]);

  useEffect(() => {
    const examenes = dataExamen ? parseInt(checked.examenes, 10) : 0;
    const cursos = dataCurso ? parseInt(checked.cursos, 10) : 0;
    cambiarPrecio(precioExamen * examenes + precioCurso * cursos);
  }, [checked, dataExamen, dataCurso, precioExamen, precioCurso, cambiarPrecio]);

  const CrearPago = async () => {
    if (precio === 0) {
      cambiarError(true);
      return;
    }
    let tabla = [];
    
    // Armamos la tabla dependiendo de cuántos seleccione
    if (dataExamen && checked.examenes > 0) {
      for (let i = 0; i < checked.examenes; i++) {
        tabla.push({
          concepto: dataExamen.concepto,
          clave: dataExamen.clave,
          precio: dataExamen.precio.toString(),
        });
      }
    }
    
    if (dataCurso && checked.cursos > 0) {
      for (let i = 0; i < checked.cursos; i++) {
        tabla.push({
          concepto: dataCurso.concepto,
          clave: dataCurso.clave,
          precio: dataCurso.precio.toString(),
        });
      }
    }

    cambiarTablaConceptos(tabla);
    cambiarError(false);

    let importe = precio.toString().concat(".00");
    const matriculaStr = String(alumno.codigo);
    
    // Calculamos el plantel con las reglas exactas para la línea de captura
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    // Extraemos solo las claves en un arreglo (ej. ["15", "15", "27"])
    const arregloClaves = tabla.map(item => item.clave);
    
    // Generamos la REFERENCIA M97 (El Centro de Mando)
    const datosReferencia = generarLineaCaptura(plantelOficialAlumno, arregloClaves, matriculaStr, precio);
    
    // CORRECCIÓN: Agregamos .banorte
    const refaux = datosReferencia.banorte.lineaDeCaptura;


    // NOTA: El fetch() hacia la base de datos fue eliminado.
    // La pantalla de FormaPago.js se encargará de registrarlo al dar clic en generar.

    // MEJORA: Mandamos también la de Bancomer para el PDF
    cambiarDatosPago({
      referencia: refaux,
      referenciaBBVA: datosReferencia.bancomer.lineaDeCaptura,
      importe: importe,
      detallesCompletos: datosReferencia
    });
    
    cambiarPagar(true);
    history.push("/formadepago");
  };

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="FormularioExamen-container container">
      <button 
        className="FormularioExamen-btn-regresar" 
        onClick={() => history.push("/tipo")}
      >
        &#8592; Regresar
      </button>

      <h2>Exámenes Extraordinarios y Cursos Intersemestrales</h2>

      {estadoCatalogo !== "listo" ? (
        <AvisoCatalogo estado={estadoCatalogo} />
      ) : !dataExamen && !dataCurso ? (
        <div className="Formulario-error">
          <p>Por ahora no hay exámenes extraordinarios ni cursos intersemestrales disponibles para pago en línea. Consulta en tu plantel.</p>
        </div>
      ) : (
      <>
      <div className="FormularioExamen-card">
        <h3>Costos Unitarios <span>Información</span></h3>
        <p>A continuación se muestran los precios para cada concepto:</p>
        
        <ul className="FormularioExamen-list">
          {dataExamen && (
          <li>
            <div className="FormularioExamen-list-item-content">
              <span>{dataExamen.concepto}</span>
              <span className="FormularioExamen-list-price">${precioExamen.toFixed(2)} c/u</span>
            </div>
          </li>
          )}
          {dataCurso && (
          <li>
            <div className="FormularioExamen-list-item-content">
              <span>{dataCurso.concepto}</span>
              <span className="FormularioExamen-list-price">${precioCurso.toFixed(2)} c/u</span>
            </div>
          </li>
          )}
        </ul>
        
        <div className="FormularioExamen-card-footer">
          <p>
            Selecciona la cantidad que necesitas de cada uno en la parte inferior para calcular tu total automáticamente.
          </p>
        </div>
      </div>

      <div className="FormularioExamen-flex">
        <div className="FormularioExamen-form">
          {dataExamen && (
          <div className="FormularioExamen-section">
            <p>¿Cuántos {dataExamen.concepto}s?</p>
            <div className="FormularioExamen-radios">
              {[0, 1, 2, 3].map((num) => (
                <label key={`exam-${num}`}>
                  <input
                    type="radio"
                    name="examenes"
                    value={num.toString()}
                    checked={checked.examenes === num.toString()}
                    onChange={HandleOnChange}
                  />
                  {num === 0 ? "Ninguno" : num}
                </label>
              ))}
            </div>
          </div>
          )}

          {dataCurso && (
          <div className="FormularioExamen-section">
            <p>¿Cuántos {dataCurso.concepto}s?</p>
            <div className="FormularioExamen-radios">
              {[0, 1, 2].map((num) => (
                <label key={`curso-${num}`}>
                  <input
                    type="radio"
                    name="cursos"
                    value={num.toString()}
                    checked={checked.cursos === num.toString()}
                    onChange={HandleOnChange}
                  />
                  {num === 0 ? "Ninguno" : num}
                </label>
              ))}
            </div>
          </div>
          )}
        </div>

        <div className="FormularioExamen-paybox">
          <div className="FormularioExamen-total">
            <h4>
              Total:
              <span>${Number(precio).toFixed(2)}</span>
            </h4>
          </div>
          {error ? (
            <div className="Formulario-error">
              <p>⚠️ Selecciona al menos un concepto para continuar.</p>
            </div>
          ) : null}
          <input
            className="Formulario-boton"
            type="button"
            onClick={CrearPago}
            value="CONTINUAR"
          />
        </div>
      </div>
      </>
      )}
    </div>
  );
};
export default FormularioExamen;